<template>
  <b-modal ref="modal" hide-footer title="Release Callback">
    <b-row class="my-1">
      <b-col md="4">
        <label for="reason">Release Reason</label>
      </b-col>
      <b-col md="8">
        <b-form-input id="reason" v-model="reason"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="9"> </b-col>
      <b-col md="3">
        <b-button
          class="mt-3"
          variant="success"
          block
          @click="saveRelease"
        >
          <font-awesome-icon icon="check" /> Save
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

export default {
  props: {
    onRelease: {
      type: Function,
      required: true
    },
    companyId: Number,
  },
  data() {
    return {
      reason: null
    };
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    saveRelease() {
      this.isBusy = true;

      this.$http.post("/company/releaseCallback",
        {
          companyId: this.companyId,
          reason: this.reason,
        }).then(() => {
        this.isBusy = false;
        this.onRelease();
        this.hideModal();
      });
    },
  },
};
</script>
